import { render } from "./followCarView.vue?vue&type=template&id=f53061d4&scoped=true"
import script from "./followCarView.vue?vue&type=script&lang=js"
export * from "./followCarView.vue?vue&type=script&lang=js"

import "./followCarView.vue?vue&type=style&index=0&id=f53061d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f53061d4"]])

export default __exports__